import core from '@gin-betting/core';
import { persistReducer } from '@gin-betting/persist';
import { noop } from 'lodash';

import moduleLocator from 'moduleLocator';
import type { Betslip, BetslipModule } from 'modules/betslip';

function handleBetslipModuleLoad(betslipModule: BetslipModule): BetslipModule {
    const {
        reducer,
        utils: { handleRehydrate },
        middleware,
        constants: { BetslipTimeManager },
    } = betslipModule;

    // eslint-disable-next-line no-param-reassign
    betslipModule.reducer = persistReducer<Betslip.BetslipState>(
        {
            key: 'betslip',
            whitelist: ['betslipBets', 'betslipOdds', 'oddUpdateStatus'],
            expireAfter: 1 * 60 * 60 * 1000,
            stateReconciler: (inboundState, _, reducedState) => {
                const rehydratedState = handleRehydrate(
                    reducedState,
                    inboundState
                );

                const rehydrateTime = Date.now();

                rehydratedState.betslipOdds.forEach(({ id }) => {
                    BetslipTimeManager[id] = rehydrateTime;
                });

                return rehydratedState.set(
                    'oddUpdateStatus',
                    inboundState.oddUpdateStatus
                );
            },
        },
        reducer
    );

    // TODO hardcode, rewrite binding bettingAPI
    betslipModule.middleware = () =>
        middleware({
            handleBet: core.utils.isDebugEnabled()
                ? bet => {
                      const betOverride = localStorage.getItem('bet-override');

                      if (betOverride) {
                          Object.assign(bet, JSON.parse(betOverride));
                      }
                  }
                : noop,
        });

    moduleLocator.set('betslip', { default: betslipModule });

    return betslipModule;
}

export default handleBetslipModuleLoad;
